module.exports = new __parcel__URL__("cornershop-iphone.00b54ee3.png").toString();